import { useState } from "react";
import { Facebook, Instagram, MessageCircle, Link2, Share2, Check } from "lucide-react";
import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function ShareButtons({ sharePath, title, text, className = "", compact = false }) {
  const [copied, setCopied] = useState(false);
  const url = `${BACKEND}/api/share/${sharePath}`;
  const message = `${title}${text ? ` — ${text}` : ""}`;

  const copy = async (hint) => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success(hint || "Lien copié !");
      setTimeout(() => setCopied(false), 2500);
    } catch {
      toast.error("Impossible de copier le lien");
    }
  };

  const nativeShare = async () => {
    try {
      await navigator.share({ title, text: message, url });
    } catch (e) {
      if (e?.name !== "AbortError") copy();
    }
  };

  const instagram = async () => {
    if (navigator.share) return nativeShare();
    copy("Lien copié — collez-le dans votre story ou votre bio Instagram");
    window.open("https://www.instagram.com/", "_blank", "noopener,noreferrer");
  };

  const btn = `inline-flex items-center justify-center gap-2 rounded-full border border-foreground/25 hover:border-primary hover:text-primary transition-colors ${compact ? "h-9 w-9" : "h-10 px-4 text-xs uppercase tracking-[0.18em]"}`;

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid="share-buttons">
      {!compact && <span className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground mr-1">Partager</span>}
      <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`} target="_blank" rel="noopener noreferrer" className={btn} title="Partager sur Facebook" data-testid="share-facebook">
        <Facebook className="w-4 h-4" />{!compact && "Facebook"}
      </a>
      <a href={`https://wa.me/?text=${encodeURIComponent(`${message} ${url}`)}`} target="_blank" rel="noopener noreferrer" className={btn} title="Partager sur WhatsApp" data-testid="share-whatsapp">
        <MessageCircle className="w-4 h-4" />{!compact && "WhatsApp"}
      </a>
      <button type="button" onClick={instagram} className={btn} title="Partager sur Instagram" data-testid="share-instagram">
        <Instagram className="w-4 h-4" />{!compact && "Instagram"}
      </button>
      <button type="button" onClick={() => copy()} className={btn} title="Copier le lien" data-testid="share-copy">
        {copied ? <Check className="w-4 h-4 text-primary" /> : <Link2 className="w-4 h-4" />}{!compact && (copied ? "Copié" : "Copier le lien")}
      </button>
      {typeof navigator !== "undefined" && navigator.share && (
        <button type="button" onClick={nativeShare} className={`${btn} border-primary/60 text-primary`} title="Plus d'options" data-testid="share-native">
          <Share2 className="w-4 h-4" />{!compact && "Plus…"}
        </button>
      )}
    </div>
  );
}
